<template lang="pug">
	content-page
		div(slot="nav")
			nav
				.subtitle-1 {{$t('destination-navigation.heading.general')}}
				ul.list-unstyled
					li
						nuxt-link(:to="localePath({name: 'resorts-resort', params: { resort: resort.slug }})" :title="$t('destination-navigation.about_resort.title_{destination}', {destination: resort.name})") {{$t('destination-navigation.about_resort')}}
					li
						nuxt-link(:to="localePath({name: 'areas-area', params: { area: resort.area.slug } })" :title="$t('destination-navigation.about_area.title', {destination: resort.name})") {{$t('destination-navigation.about_area')}}
					li
						nuxt-link(:to="localePath({name: 'resorts-resort-reviews', params: { resort: resort.slug }})" :title="$t('destination-navigation.reviews.title', {destination: resort.name})") {{$t('destination-navigation.reviews')}}
					li
						nuxt-link(:to="localePath({name: 'resorts-resort-skipas', params: { resort: resort.slug }})" :title="$t('destination-navigation.skipasses.title', {destination: resort.name})") {{$t('destination-navigation.skipasses')}}
					li
						nuxt-link(:to="localePath({name: 'resorts-resort-reachability', params: { resort: resort.slug }})" :title="$t('destination-navigation.reachability.title', {destination: resort.name})") {{$t('destination-navigation.reachability')}}
					li
						nuxt-link(v-if="$i18n.locale !== 'de-DE'" :to="localePath({name: 'resorts-resort-forum', params: { resort: resort.slug }})" :title="$t('destination-navigation.forum.title', {destination: resort.name})") {{$t('destination-navigation.forum')}}
				.subtitle-1 {{$t('destination-navigation.heading.conditions')}}
				ul.list-unstyled
					li(v-if="resort.stats.hasForecast")
						nuxt-link(:to="localePath({name: 'resorts-resort-forecast', params: { resort: resort.slug }})" :title="$t('destination-navigation.forecast.title', {destination: resort.name})") {{$t(`destination-navigation.forecast`)}}
					li(v-if="resort.area.stats.hasSnowheights")
						nuxt-link(:to="localePath({name: 'resorts-resort-snowheight', params: { resort: resort.slug }})" :title="$t('destination-navigation.snowheight.title', {destination: resort.name})") {{$t(`destination-navigation.snowheight`)}}
					li(v-if="resort.area.stats.webcamCount")
						nuxt-link(:to="localePath({name: 'resorts-resort-webcams', params: { resort: resort.slug }})" :title="$t('destination-navigation.webcams.title', {destination: resort.name}) ")
							| {{$t(`destination-navigation.webcams`)}}
							|
							small.grey--text ({{resort.area.stats.webcamCount}})
					li
						nuxt-link(:to="localePath({name: 'resorts-resort-snowguarantee', params: { resort: resort.slug }})" :title="$t('destination-navigation.snowguarantee.title', {destination: resort.name}) ") {{$t('destination-navigation.snowguarantee')}}
				template(v-if="$i18n.locale !== 'de-DE'")
					.subtitle-1 {{$t('destination-navigation.heading.accommodations')}}
					ul.list-unstyled
						li
							nuxt-link(:to="localePath({name: 'resorts-resort-accommodationtype', params: { accommodationtype: $localeSlug('accommodaties', $i18n.locale), resort: resort.slug }})" :title="$t('destination-navigation.accommodations.all.title', {destination: resort.name})")
								| {{$t('destination-navigation.accommodations.all')}}
								|
								small.grey--text ({{resort.stats.accommodationCount}})
						li
							nuxt-link(:to="localePath({name: 'resorts-resort-accommodationtype', params: { accommodationtype: $localeSlug('appartementen', $i18n.locale), resort: resort.slug }})" :title="$t('destination-navigation.accommodations.apartments.title', {destination: resort.name})")
								| {{$t('destination-navigation.accommodations.apartments')}}
								|
								small.grey--text ({{resort.stats.apartmentCount}})
						li
							nuxt-link(:to="localePath({name: 'resorts-resort-accommodationtype', params: { accommodationtype: $localeSlug('hotels', $i18n.locale), resort: resort.slug }})" :title="$t('destination-navigation.accommodations.hotels.title', {destination: resort.name})")
								| {{$t('destination-navigation.accommodations.hotels')}}
								|
								small.grey--text ({{resort.stats.hotelCount}})
						li
							nuxt-link(:to="localePath({name: 'resorts-resort-accommodationtype', params: { accommodationtype: $localeSlug('pensions', $i18n.locale), resort: resort.slug }})" :title="$t('destination-navigation.accommodations.pensions.title', {destination: resort.name})")
								| {{$t('destination-navigation.accommodations.pensions')}}
								|
								small.grey--text ({{resort.stats.pensionCount}})
						li
							nuxt-link(:to="localePath({name: 'resorts-resort-accommodationtype', params: { accommodationtype: $localeSlug('chalets', $i18n.locale), resort: resort.slug }})" :title="$t('destination-navigation.accommodations.chalets.title', {destination: resort.name})")
								| {{$t('destination-navigation.accommodations.chalets')}}
								|
								small.grey--text ({{resort.stats.chaletCount}})
				div(v-if="resort.stats.restaurantCount || resort.stats.apresskiCount || resort.stats.rentalCount || resort.stats.lessonCount")
					.subtitle-1 {{$t(`destination-navigation.heading.locations`)}}
					ul.list-unstyled
						li(v-if="resort.stats.restaurantCount")
							nuxt-link(:to="localePath({name: 'resorts-resort-restaurants', params: { resort: resort.slug }})" :title="$t('destination-navigation.locations.restaurants.title', {destination: resort.name})")
								| {{$t(`destination-navigation.locations.restaurants`)}}
								|
								small.grey--text ({{resort.stats.restaurantCount}})
						li(v-if="resort.stats.apresskiCount")
							nuxt-link(:to="localePath({name: 'resorts-resort-apresski', params: { resort: resort.slug }})" :title="$t('destination-navigation.locations.apresski.title', {destination: resort.name})")
								| {{$t(`destination-navigation.locations.apresski`)}}
								|
								small.grey--text ({{resort.stats.apresskiCount}})
						li(v-if="resort.stats.rentalCount && $i18n.locale !== 'de-DE'")
							nuxt-link(:to="localePath({name: 'resorts-resort-rental', params: { resort: resort.slug }})" :title="$t('destination-navigation.locations.rental.title', {destination: resort.name})")
								| {{$t(`destination-navigation.locations.rental`)}}
								|
								small.grey--text ({{resort.stats.rentalCount}})
						li(v-if="resort.stats.lessonCount && $i18n.locale !== 'de-DE'")
							nuxt-link(:to="localePath({name: 'resorts-resort-lesson', params: { resort: resort.slug }})" :title="$t('destination-navigation.locations.lessons.title', {destination: resort.name})")
								| {{$t(`destination-navigation.locations.lessons`)}}
								|
								small.grey--text ({{resort.stats.lessonCount}})
		div.hidden-sm-and-down(slot="sidebar" v-if="showSidebar" style="max-width: 280px;")
			ad(location="sidebar").mb-6
			snow-alarm.mb-6(:initial-destination-id="resort.id" initial-destination-type="resort" :initial-destination-name="resort.name")
			offers.mb-6
		.flow-left
			nuxt-child(:showSidebar.sync="showSidebar")
</template>

<script>
import gql from 'graphql-tag';
import { interpolateFields } from '@/utils/interpolate.js';

export default {
	name: 'ResortsResort',
	nuxtI18n: {
		paths: {
			'nl-NL': '/dorpen/:resort',
			'de-DE': '/skiorte/:resort',
			'nl-BE': '/dorpen/:resort'
		}
	},
	layout: 'default',
	middleware({ app, params }) {
		return app.$graphClient
			.query({
				query: gql`
					query getResortBase($slug: String!) {
						resort(slug: $slug) {
							id
							name
							slug
							country {
								id
								name
								countryCode
								slug
							}
							region {
								id
								name
								slug
							}
							reviews(limit: 1) {
								average
								voteCount
								recommendedPercent
							}
							stats {
								webcamCount
								hasForecast
								hasSnowheights
								restaurantCount
								apresskiCount
								rentalCount
								lessonCount
								accommodationCount
								apartmentCount
								hotelCount
								pensionCount
								chaletCount
							}
							area {
								id
								name
								slug
								stats {
									webcamCount
									hasForecast
									hasSnowheights
									restaurantCount
									apresskiCount
									rentalCount
									lessonCount
									accommodationCount
									apartmentCount
									hotelCount
									pensionCount
									chaletCount
								}
								slopeinfo {
									total
									gondola
									chairlift
									tbar
									magiccarpet
								}
								snowheights {
									maxSnowMountain
									maxSnowValley
									nodes {
										elevatorsOpen
										slopeLengthOpen
										slopeLength
									}
								}
							}
						}
					}
				`,
				variables: {
					slug: params.resort
				}
			})
			.then(({ data, _errors }) => {
				app.data = data;
				const interpolationData = {
					resort: data.resort.name,
					country: data.resort.country.name,
					'webcams.total': data.resort.area.stats.webcamCount,
					'pistes.total': data.resort.area.slopeinfo.total,
					'lifts.total':
						data.resort.area.slopeinfo.gondola +
						data.resort.area.slopeinfo.chairlift +
						data.resort.area.slopeinfo.tbar +
						data.resort.area.slopeinfo.magiccarpet,
					'reviews.average': data.resort.reviews.average,
					'reviews.total': data.resort.reviews.total,
					'reviews.recommended': data.resort.reviews.recommendedPercent,
					'apresski.total': data.resort.stats.apresskiCount,
					'restaurants.total': data.resort.stats.restaurantCount,
					'accommodations.total': data.resort.stats.accommodationCount,
					'apartments.total': data.resort.stats.apartmentCount,
					'pensions.total': data.resort.stats.pensionCount,
					'chalets.total': data.resort.stats.chaletCount,
					'hotels.total': data.resort.stats.hotelCount,
					'touroperators.total': 15,
					'snowheight.valley': data.resort.area.snowheights.maxSnowValley,
					'snowheight.mountain': data.resort.area.snowheights.maxSnowMountain,
					...data.resort.area.snowheights.nodes.reduce(
						(carry, snowheight) => {
							carry['slopelength.open'] += snowheight.slopeLengthOpen;
							carry['slopelength.total'] += snowheight.slopeLength;
							carry['lifts.open'] += snowheight.elevatorsOpen;
							return carry;
						},
						{ 'slopelength.open': 0, 'slopelength.total': 0, 'lifts.open': 0 }
					)
				};
				app.interpolater = interpolateFields({
					find: RegExp(`{(${Object.keys(interpolationData).join('|')})}`, 'gi'),
					replace: (match, group) => {
						return interpolationData[group];
					}
				});
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'resort-slug-interpolater', error);
			});
	},
	scrollToTop: true,
	// eslint-disable-next-line @milqmedia/milq/page-has-ads, @milqmedia/milq/page-has-meta
	asyncData({ app }) {
		return app.data;
	},
	data() {
		return {
			showSidebar: false
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
